
import React from "react";
import { Users } from "lucide-react";

const UserProfilesHeader = () => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-xl font-bold flex items-center gap-2">
        <Users className="text-blue-500" />
        Registered Users
      </h2>
    </div>
  );
};

export default UserProfilesHeader;

